import { call, put, select } from 'redux-saga/effects';
import { chatImagesClearPending, selectPendingChatImages } from 'features/chat/chatSlice';
import { revokeBlobUrls } from 'features/chat/utils/revokeBlobUrls';
import { PendingChatImage } from 'features/chat/types';

export function* clearPendingImagesSaga() {
  const pendingImages: PendingChatImage[] = yield select(selectPendingChatImages);
  if (pendingImages.length === 0) {
    return;
  }
  yield call(
    revokeBlobUrls,
    pendingImages.map((pending) => pending.previewUrl)
  );
  yield put(chatImagesClearPending());
}
